import { Helmet } from 'react-helmet-async';
import CategoryPageTemplate from '../components/CategoryPageTemplate';
import { AGARBATTI } from '../data/products';

const heroImg = "/images/abouthero.webp";

const AGARBATTI_TIERS = [
  { id: "Premium",       label: "Premium",       icon: "⭐", desc: "Elevated experience",  badge: "LATEST" },
  { id: "Extra Premium", label: "Extra Premium",  icon: "💎", desc: "Luxury & gifting",     badge: "NEW" },
  { id: "Scented",       label: "Scented",        icon: "🌸", desc: "Everyday fragrance",   badge: null },
  { id: "All",           label: "All Products",   icon: "✦", desc: "",                     badge: null },
];

export default function AgarbattiPage() {
  return (
    <>
      <Helmet>
        <title>Buy Agarbatti Online | Premium Masala Incense Sticks — Prakhyat</title>
        <meta
          name="description"
          content="Shop Prakhyat Agarbatti online — Premium, Extra Premium & Scented Masala Incense Sticks in 40+ fragrances. Sandalwood, Oud, Rose, Lavender & more. 100% natural ingredients. Perfect for Pooja, Meditation & Yoga."
        />
        <meta
          name="keywords"
          content="buy agarbatti online, premium masala agarbatti, extra premium agarbatti, scented agarbatti, sandalwood agarbatti, oud agarbatti, rose agarbatti, lavender agarbatti, pooja agarbatti, meditation incense sticks, natural agarbatti india, prakhyat agarbatti, chandan agarbatti, masala incense sticks"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://prakhyatagarbatti.com/products/agarbatti" />
      </Helmet>

      <CategoryPageTemplate
        title="Agarbatti Collection"
        subtitle="Pure fragrance, handcrafted with devotion — for every ritual and every home"
        products={AGARBATTI}
        heroBg={heroImg}
        tiers={AGARBATTI_TIERS}
        seoDesc="Buy premium Agarbatti from Prakhyat — 100% natural. Made in Mumbai, Maharashtra."
      />
    </>
  );
}